import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const Table_Collapse = () => {
  return (
    <div className="tutorial-container">
      <h1 className="tutorial-title">🧩 CSS Table Collapse</h1>

      <p className="tutorial-intro">
        By default, when you apply borders to a table, the borders of cells and
        the table itself may appear as <strong>double borders</strong>. The{" "}
        <code>border-collapse</code> property controls whether table borders are
        separated or collapsed into a single border.
      </p>

      {/* Info Box */}
      <div
        style={{
          background: "linear-gradient(135deg, #ede9fe, #ddd6fe)",
          padding: "1rem",
          paddingLeft: "3rem",
          borderRadius: "12px",
          marginBottom: "2rem",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "#5b21b6", marginBottom: "0.5rem" }}>
          ✨ border-collapse Values
        </h2>
        <ul style={{ textAlign: "left", lineHeight: "1.8" }}>
          <li>
            <code>separate</code> – Default. Borders are separated (double).
          </li>
          <li>
            <code>collapse</code> – Borders collapse into a single border.
          </li>
        </ul>
      </div>

      {/* Without Collapse */}
      <div className="tutorial-section">
        <h2 className="section-title" style={{ color: "#dc2626" }}>
          🔹 Table Without Collapse (Default)
        </h2>
        <p>
          By default, borders are separated, so each cell and the table border
          are drawn individually.
        </p>

        <CodeCopyBlock
          code={`table {
  border: 2px solid red;
  border-collapse: separate; /* default */
}

td, th {
  border: 2px solid red;
  padding: 8px;
}`}
        />

        <table
          style={{
            border: "2px solid red",
            borderCollapse: "separate",
            marginTop: "1rem",
          }}
        >
          <tr>
            <th style={{ border: "2px solid red", padding: "8px" }}>Name</th>
            <th style={{ border: "2px solid red", padding: "8px" }}>Age</th>
          </tr>
          <tr>
            <td style={{ border: "2px solid red", padding: "8px" }}>Alice</td>
            <td style={{ border: "2px solid red", padding: "8px" }}>22</td>
          </tr>
        </table>
      </div>

      {/* With Collapse */}
      <div className="tutorial-section">
        <h2 className="section-title" style={{ color: "#16a34a" }}>
          🔹 Table With Collapse
        </h2>
        <p>
          Using <code>border-collapse: collapse;</code> merges adjacent borders
          into a single clean line.
        </p>

        <CodeCopyBlock
          code={`table {
  border: 2px solid green;
  border-collapse: collapse; /* collapse borders */
}

td, th {
  border: 2px solid green;
  padding: 8px;
}`}
        />

        <table
          style={{
            border: "2px solid green",
            borderCollapse: "collapse",
            marginTop: "1rem",
          }}
        >
          <tr>
            <th style={{ border: "2px solid green", padding: "8px" }}>Name</th>
            <th style={{ border: "2px solid green", padding: "8px" }}>Age</th>
          </tr>
          <tr>
            <td style={{ border: "2px solid green", padding: "8px" }}>Bob</td>
            <td style={{ border: "2px solid green", padding: "8px" }}>28</td>
          </tr>
        </table>
      </div>

      {/* Collapse with Padding */}
      <div className="tutorial-section">
        <h2 className="section-title" style={{ color: "#2563eb" }}>
          🔹 Collapse with Padding
        </h2>
        <p>
          You can still use <code>padding</code> to create space inside cells
          while keeping borders collapsed.
        </p>

        <CodeCopyBlock
          code={`table {
  border: 2px solid blue;
  border-collapse: collapse;
}

td, th {
  border: 2px solid blue;
  padding: 15px; /* extra padding */
}`}
        />

        <table
          style={{
            border: "2px solid blue",
            borderCollapse: "collapse",
            marginTop: "1rem",
          }}
        >
          <tr style={{ background: "#dbeafe" }}>
            <th style={{ border: "2px solid blue", padding: "15px" }}>City</th>
            <th style={{ border: "2px solid blue", padding: "15px" }}>
              Country
            </th>
          </tr>
          <tr>
            <td style={{ border: "2px solid blue", padding: "15px" }}>Paris</td>
            <td style={{ border: "2px solid blue", padding: "15px" }}>
              France
            </td>
          </tr>
        </table>
      </div>

      {/* Next Steps */}
      <div
        style={{
          background: "linear-gradient(135deg, #fef9c3, #fde047)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "#854d0e", marginBottom: "0.5rem" }}>
          🚀 Next Steps
        </h2>
        <p style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
          Try combining <code>border-collapse</code> with{" "}
          <code>border-spacing</code> to fine-tune the spacing between table
          cells.
        </p>
      </div>
    </div>
  );
};

export default Table_Collapse;
